import React from 'react';
import PropTypes from 'prop-types';

import Icon, { ICON_TYPE } from '../base/icon';
import InfoboxStyles from './infoboxStyles';

const TYPE = {
  info: {
    iconType: ICON_TYPE.INFO,
    iconColor: '#FFB900',
    backgroundColor: '#FFF6E0',
  },
  warning: {
    iconType: ICON_TYPE.INFO,
    iconColor: '#F85C50',
    backgroundColor: '#FFDFDC',
  },
};

const Infobox = props => {
  const { iconType, iconColor, backgroundColor } = TYPE[props.type];

  return (
    <InfoboxStyles
      mb={props.mb}
      mt={props.mt}
      iconType={iconType}
      backgroundColor={backgroundColor}
    >
      {!props.noIcon && <Icon color={iconColor} type={iconType} width={16} height={16} mr={1} />}
      {props.children}
    </InfoboxStyles>
  );
};

Infobox.propTypes = {
  type: PropTypes.oneOf(['info', 'warning']),
  noIcon: PropTypes.bool,
  mt: PropTypes.number,
  mb: PropTypes.number,
  children: PropTypes.node,
};

Infobox.defaultProps = {
  type: 'info',
  noIcon: false,
  mb: 0,
  mt: 0,
};

export default Infobox;
